import {
  PendingReviewModelType,
  Review,
  ReviewMetadata,
  UserState,
  WorkInfo,
} from '@company/types/comm-hub.type';
import IJobDetail, { JobAssignment } from '@th-types/job.detail.type';
import { CompanyRating, Reviewer } from '@th-types/rating.type';
import { IWorkerData } from '@th-types/worker.type';

export class PendingReviewModel implements ReviewMetadata {
  jobAssignmentId: number;

  eventName: string;

  workerId: number | null;

  workerFullName: string | null;

  jobId: number;

  completed?: boolean;

  reviewer?: Reviewer;

  job?: IJobDetail;

  distance?: number;

  worker?: IWorkerData;

  companyRating?: CompanyRating;

  workInfo?: WorkInfo;

  userState?: UserState;

  reviewType: PendingReviewModelType;

  constructor(pendingReview: Review | JobAssignment) {
    if ((pendingReview as Review).companyRating) {
      const review = pendingReview as Review;
      this.jobAssignmentId = review.jobAssignmentId;
      this.eventName = review.eventName;
      this.workerId = review.workerId;
      this.workerFullName = review.workerFullName || null;
      this.jobId = review.jobId;
      this.companyRating = review.companyRating;
      this.workInfo = review.workInfo;
      this.userState = review.userState;
      this.completed = review.completed;
      this.reviewType = PendingReviewModelType.REVIEW_REQUEST;
    } else {
      const jobAssignment = pendingReview as JobAssignment;
      this.jobAssignmentId = jobAssignment.id;
      this.eventName = jobAssignment.job.eventName;
      this.workerId = jobAssignment.worker.id;
      this.workerFullName = jobAssignment.worker?.fullName ?? 'N/A';
      this.jobId = jobAssignment.job.id;
      this.completed = undefined;
      this.reviewer = undefined;
      this.job = jobAssignment.job;
      this.distance = jobAssignment.distance;
      this.worker = jobAssignment.worker;
      this.reviewType = PendingReviewModelType.TH_GIG_PENDING_REVIEW;
    }
  }

  getUniqueKey(): string {
    const id =
      this.jobAssignmentId ??
      this.companyRating?.id ??
      `${this.jobId}-${this.workerId}`;
    return `${this.reviewType}-${id}`;
  }

  getJobId(): number | undefined {
    return this.jobId;
  }

  getWorkerId(): number | null {
    return this.workerId;
  }

  getWorkerName(): string {
    return this.workerFullName ?? 'N/A';
  }

  getBrandRepresented(): string | undefined {
    return this.job?.brandRepresented;
  }

  getEventName(): string | undefined {
    return this.job?.eventName;
  }

  getDistance(): number | undefined {
    return this.distance;
  }

  getAddress(): string {
    return `${this.job?.address?.city}, ${this.job?.address?.state?.ansiAbbreviation}`;
  }

  getStart(): Date | undefined {
    return this.job?.start;
  }

  getEnd(): Date | undefined {
    return this.job?.end;
  }

  getProfileImageUrl(): string | undefined {
    return this.worker?.profileImageUrl;
  }

  getRating(): number | null | undefined {
    return this.worker?.rating;
  }
}
